<div class="relative" (clickOutside)="closeDropdown()">
    <div
        class="bg-white max-w-[220px] text-gray-500 rounded-full border border-gray-300 py-3 px-4 outline-none w-full flex-col justify-start items-start gap-1.5 inline-flex">
        <div (click)="toggleDropdown()" class="text-black font-semibold text-lg flex justify-between items-center w-full">
            <span>{{selectedItem ? ('shared.floor-dropdown.options.' + selectedItem.key | transloco) : title}}</span>
            <i class="w-5 h-5 text-md font-normal text-black"
                [ngClass]="showResults ? 'icon-chevron-down' : 'icon-chevron-up'"></i>
        </div>
    </div>

    <div *ngIf="showResults"
        class="absolute left-0 top-full z-[79] md:mt-1 flex flex-col max-w-[220px] translate-y-3 md:rounded-xl p-4 gap-1 md:shadow-2xl overflow-y-auto md:overflow-x-hidden w-full bg-white">
        <label *ngFor="let item of dropdownItems; let i = index" role="button" [attr.for]="'floor-dropdown-item-'+i"
            class="menu-item-checkmark" [ngClass]="{'text-gray-950': item.disabled === false, 'text-gray-300': item.disabled === true, 'checked': selectedItem && selectedItem === item }">
            <input type="checkbox" class="hidden" [attr.id]="'floor-dropdown-item-'+i" [name]="'floor-dropdown-item-'+i"
                (change)="onFloorSelect(item)" [checked]="selectedItem && selectedItem === item" [disabled]="item.disabled">
            <div class="menu-item-checkmark-content">
                <span class="menu-item-checkmark-text">{{ 'shared.floor-dropdown.options.' + item.key | transloco }}</span>
            </div>
        </label>
    </div>
</div>